import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs } from '@mui/material';
import { change } from 'redux-form';
import ServiceProviderForm from '../ServiceProviderForm';
import { notifySet } from '../../Services/Actions/CommonActions';
import { editServiceProvider, serviceProviderFormEditSubmit } from '../../Services/Utils/ServiceProviderApis';
import { uploadImages } from '../../Services/Utils/CommonApis';
import { getImage } from '../../Services/Utils/FileApis';

function EditServiceProvider() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const [currentLogo, setCurrentLogo] = useState({});

  useEffect(() => {
    editServiceProvider({ id: params.id }).then((res) => {
      dispatch(change('ServiceProviderForm', 'serviceprovidername', res.view.name));
      dispatch(change('ServiceProviderForm', 'websiteURL', res.view.website));
      dispatch(change('ServiceProviderForm', 'briefIntroduction', res.view.brief));
      dispatch(change('ServiceProviderForm', 'dealDetail', res.view.dealDetails));
      dispatch(change('ServiceProviderForm', 'dealRedemptionProcess', res.view.redemptionProcess));
      dispatch(change('ServiceProviderForm', 'dealRedemptionLink', res.view.redemptionLink));
      dispatch(change('ServiceProviderForm', 'estimatedValue', res.view.estimatedPerks));
      dispatch(change('ServiceProviderForm', 'eligibilityCriteria', res.view.eligibility));
      dispatch(change('ServiceProviderForm', 'PoCName', res.view.pocName));
      dispatch(change('ServiceProviderForm', 'PoCEmailID', res.view.pocEmail));
      dispatch(change('ServiceProviderForm', 'remark', res.view.remarks));
      dispatch(change('ServiceProviderForm', 'phoneNumber', res.view.pocMobile));
      dispatch(change('ServiceProviderForm', 'referrerName', res.view.referrerName));
      const hearAboutUs = {
        label: res.view.hearAboutUs,
        value: res.view.hearAboutUs
      };
      dispatch(change('ServiceProviderForm', 'hearAboutUs', hearAboutUs));
      dispatch(change('ServiceProviderForm', 'hearOther', res.view.hearOther));
      setCurrentLogo(res.view.logoView);
      const category = {
        id: res.view.categoryView.id,
        text: res.view.categoryView.name,
        to: res.view.categoryView.keyword,
        path: getImage(res.view.categoryView),
      };
      dispatch(change('ServiceProviderForm', 'serviceCategory', category));
      const status = { id: res.view.status.key, label: res.view.status.value, value: res.view.status.value };
      dispatch(change('ServiceProviderForm', 'status', status));
      res.view.serviceProviderFileViews?.map((data) => {
        productGuides.push({
          type: data.type,
          data: (data.type === 'file') ? data.fileView.fileId : data.linkUrl,
          fileId: (data.type === 'file') ? data.fileView.fileId : '',
          title: (data.type === 'file') ? data.fileView.originalName : data.linkUrl
        });
      });
      setProductGuides(productGuides);
      const logoView = [];
      logoView.push({
        uid: res.view.logoView?.id,
        id: res.view.logoView?.id,
        name: res.view.logoView?.name,
        status: 'done',
        url: getImage(res.view.logoView),
        fileId: res.view.logoView?.fileId,
      });
      setLogoImage(logoView);
    });
  }, []);

  const [file, setFile] = useState([]);
  const [logoImage, setLogoImage] = useState([]);
  let logoId = '';
  const handleFileChange = ({ fileList: newFileList }) => setFile(newFileList);

  function getFields(input, field) {
    let output = null;
    for (let i = 0; i < input.length; ++i) output = input[i][field];
    return output;
  }

  const handleChangeLogo = ({ fileList: newFileList }) => {
    setLogoImage(newFileList);
  };

  const [uploadResponses, setUploadResponses] = useState([]);

  const fileUpload = async (imageFile, type) => (
    new Promise((resolve) => {
      const imageData = getFields(imageFile, 'originFileObj');
      uploadImages({ file: imageData }).then((res) => {
        uploadResponses.push({
          file: res,
          type,
        });
        resolve(res);
      });
    })
  );

  const onButtonClick = async (formData) => {
    const ProductGuide = [];
    const promises = [];

    logoImage.forEach((imageData) => {
      if (!imageData.fileId) {
        promises.push(fileUpload(logoImage, 'logo'));
      } else {
        logoId = imageData.fileId;
      }
    });

    productGuides.forEach((guide) => {
      if (guide.type === 'link') {
        ProductGuide.push({
          linkUrl: guide.data,
          type: guide.type,
        });
      } else if (guide.type === 'file' && !guide.fileId) {
        promises.push(fileUpload(guide.data, 'product-guide'));
      } else {
        ProductGuide.push({
          fileView: {
            fileId: guide.data,
          },
          type: guide.type,
        });
      }
    });

    Promise.all(promises).then(async () => {
      uploadResponses.forEach(async (response) => {
        if (response.type === 'logo') {
          logoId = response.file.view.fileId;
        } else {
          ProductGuide.push({
            fileView: {
              fileId: response.file.view.fileId,
            },
            type: 'file',
          });
        }
      });

      const serviceProviderFinalData = {
        id: params.id,
        categoryView: {
          id: formData.serviceCategory.id,
        },
        logoView: {
          fileId: logoId,
        },
        serviceProviderFileViews: ProductGuide,
        name: formData.serviceprovidername,
        estimatedPerks: formData.estimatedValue,
        website: formData.websiteURL,
        brief: formData.briefIntroduction,
        dealDetails: formData.dealDetail,
        redemptionProcess: formData.dealRedemptionProcess,
        redemptionLink: formData.dealRedemptionLink,
        eligibility: formData.eligibilityCriteria,
        remarks: formData.remark,
        pocName: formData.PoCName,
        pocEmail: formData.PoCEmailID,
        pocMobile: formData.phoneNumber,
        status: { id: formData.status.id },
        referrerName: formData.referrerName,
        hearAboutUs: formData.hearAboutUs.value,
        hearOther: formData.hearAboutUs.value === 'Others' ? formData.hearOther : ''
      };
      await serviceProviderFormEditSubmit(serviceProviderFinalData).then((response) => {
        const { hasError } = response;
        if (hasError === false) {
          setUploadResponses([]);
          navigate('/service-provider-master');
          dispatch(notifySet({ type: 'success', message: response.message }));
        } else if (hasError === true) {
          dispatch(notifySet({ type: 'error', message: response.message }));
        }
      });
    });
  };

  // add product guide
  const [openProductGuide, setOpenProductGuide] = useState(false);
  const productGuideUploadOptions = [
    { id: 1, label: 'File', value: 'file' },
    { id: 2, label: 'Link', value: 'link' }
  ];
  const [option, setOption] = useState(productGuideUploadOptions[0]);
  const [productGuides, setProductGuides] = useState([]);
  const [linkURL, setLinkURL] = useState('');

  const saveProductGuide = () => {
    const guide = {
      type: option.value,
      data: (option.value === 'file') ? file : linkURL,
      title: (option.value === 'file') ? file[0].name : linkURL
    };
    productGuides.push(guide);
    setProductGuides(productGuides);
    setOpenProductGuide(false);
    resetModal();
  };

  const resetModal = () => {
    setLinkURL('');
    setFile([]);
    setOption(productGuideUploadOptions[0]);
  };

  const cancelProductGuide = () => {
    setOpenProductGuide(false);
    resetModal();
  };

  return (
    <div className="container-fluid ">
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/service-provider-master">Service Partners</Link>
          <Link to="#">Edit Service Partner</Link>
        </Breadcrumbs>
      </div>
      <h6>Edit Service Partner</h6>
      <div className="row">
        <div className="col-sm-12">
          <div>
            <ServiceProviderForm
              onButtonClick={onButtonClick}
              currentLogo={currentLogo}
              buttonSaveText="Save Changes"
              file={file}
              logoImage={logoImage}
              handleChangeLogo={handleChangeLogo}
              handleFileChange={handleFileChange}
              action="edit"
              saveProductGuide={saveProductGuide}
              productGuideUploadOptions={productGuideUploadOptions}
              option={option}
              setOption={setOption}
              linkURL={linkURL}
              productGuides={productGuides}
              open={openProductGuide}
              setOpen={setOpenProductGuide}
              setLinkURL={setLinkURL}
              setProductGuides={setProductGuides}
              cancelProductGuide={cancelProductGuide}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditServiceProvider;
